<div class="top-body" [class.resized]="isResized">
    <router-outlet></router-outlet>
</div>

<kendo-dialog title="⚠️ Having Trouble Staying Logged In?" *ngIf="showCookiePopup" (close)="close()" [minWidth]="250" [width]="750">
	<div style="margin: 10px;">
        <p>It looks like you're having issues staying logged in while using Chrome. This may be due to your browser settings. Here are a few things you can try:</p>
        <ul class="nolist">
            <li>Open the site in Incognito Mode (Ctrl+Shift+N) — let us know if it works.</li>
            <li>Disable any ad blockers or privacy extensions temporarily.</li>
            <li>Go to chrome://settings/cookies, and make sure cookies are enabled.</li>
            <li>Add our site to “Sites that can always use cookies.”</li>
            <li>Clear browser cache/cookies just for our site (chrome://settings/siteData).</li>
        </ul>
        <p>Still having trouble? Try using Microsoft Edge or contact our support team for help.</p>
	</div>
</kendo-dialog>